import { useRef, useCallback } from 'react';
import { mergeRefs } from 'use-callback-ref';
import '../../utils/assertions.es.js';
import { noop } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { useKeyPressWithCallback } from '../../hooks/useKeyPress/useKeyPressWithCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useModal = (props) => {
  const { isOpen, onClose = noop, isDismissible = true, closeOnOverlayClick } = props;
  const modalRef = useRef(null);
  const modalWrapperRef = useRef(null);
  const mouseDownTarget = useRef(null);
  const handleMouseDown = useCallback((event) => mouseDownTarget.current = event.target, []);
  const handleWrapperClick = useCallback((event) => {
    event.stopPropagation();
    if (mouseDownTarget.current !== event.target || modalWrapperRef.current !== event.target || !closeOnOverlayClick || !isDismissible) {
      return;
    }
    onClose == null ? void 0 : onClose();
  }, [closeOnOverlayClick, isDismissible, onClose]);
  const getModalProps = useCallback((props2 = {}, ref = null) => __spreadProps(__spreadValues({}, props2), {
    ref: mergeRefs([ref, modalRef]),
    role: "dialog",
    tabIndex: -1,
    "aria-modal": true
  }), []);
  const getModalWrapperProps = useCallback(() => ({ ref: modalWrapperRef, onClick: handleWrapperClick, onMouseDown: handleMouseDown }), [handleWrapperClick, handleMouseDown]);
  useKeyPressWithCallback("Escape", () => isDismissible && (onClose == null ? void 0 : onClose()));
  return { isOpen, onClose, isDismissible, getModalProps, getModalWrapperProps };
};

export { useModal };
//# sourceMappingURL=useModal.es.js.map
